const environment = (typeof window !== 'undefined' && window.PlatformSetup) || {
  production: true,
  siteApi: 'https://tonybet.com',
  sentryKey: 'https://913196a6014545bda28200a38ba9826a@sentry.softlabs.com/9',
  sentryEnvironment: 'production',
};

module.exports = {
  environment,
};
